<section class="hero is-light is-small mb-4"><div class="hero-body"><p class="title"><slot></slot></p></div></section>